import { fmtTime } from "@/lib/gatePass";
import AuthPhoto from "@/components/gate/AuthPhoto";

export const TABS = [["customer_exits", "Customer Exits"], ["test_rides", "Test Rides"], ["vehicle_log", "Other Vehicles"]];

const name = (v) => (v && typeof v === "object" ? v.name : v) || "—";
const photo = (path, id) => <AuthPhoto path={path} className="w-16 h-16 object-cover border border-canvas-line" testId={id} />;

const COLS = {
  customer_exits: [
    ["Pass", (r) => <span className="font-mono text-xs">{r.pass_no}</span>],
    ["Branch", (r) => r.branch_name],
    ["Invoice", (r) => <><div>{r.invoice_number}</div><div className="text-[10px] text-ink-muted uppercase">{r.invoice_type === "counter_sale" ? "Counter sale" : "Job card"}</div></>],
    ["Vehicle / Customer", (r) => <><b>{r.vehicle_reg_no || "—"}</b><div className="text-xs text-ink-muted">{r.customer_name}</div></>],
    ["Issued", (r) => fmtTime(r.issued_at)],
    ["Exit", (r) => (r.exit_at ? fmtTime(r.exit_at) : <span className="text-[#b45309] font-semibold">Not exited</span>)],
    ["Guard", (r) => name(r.exit_scanned_by)],
    ["Photo", (r) => photo(r.exit_photo_path, `gr-photo-${r.id}`)],
  ],
  test_rides: [
    ["Pass", (r) => <span className="font-mono text-xs">{r.pass_no}</span>],
    ["Branch", (r) => r.branch_name],
    ["Job Card / Vehicle", (r) => <><div className="font-mono text-xs">{r.job_card_number}</div><b>{r.vehicle_reg_no || "—"}</b></>],
    ["Technician", (r) => r.technician],
    ["Exit", (r) => <>{fmtTime(r.exit_at)}<div className="text-xs text-ink-muted">{r.exit_odometer_km ?? "—"} km</div></>],
    ["Return", (r) => <>{r.return_at ? fmtTime(r.return_at) : r.status === "out" ? <span className="text-[#b45309] font-semibold">Still out</span> : "—"}<div className="text-xs text-ink-muted">{r.return_odometer_km ?? "—"} km</div></>],
    ["KM", (r) => <b>{r.km_driven ?? "—"}</b>],
    ["Minutes", (r) => <span className={r.overdue ? "text-[#b91c1c] font-bold" : ""}>{r.minutes_out ?? "—"}{r.overdue ? " LATE" : ""}</span>],
    ["Photos (out / back)", (r) => <div className="flex gap-1">{photo(r.exit_photo_path, `gr-exit-${r.id}`)}{photo(r.return_photo_path, `gr-ret-${r.id}`)}</div>],
  ],
  vehicle_log: [
    ["Time", (r) => fmtTime(r.recorded_at)],
    ["Branch", (r) => r.branch_name],
    ["Direction", (r) => <span className="font-mono text-xs uppercase">{r.direction}</span>],
    ["Vehicle", (r) => <b className="font-mono">{r.vehicle_reg_no}</b>],
    ["Purpose", (r) => <span className="capitalize">{r.purpose}</span>],
    ["Notes", (r) => r.notes || "—"],
    ["Guard", (r) => name(r.recorded_by)],
    ["Photo", (r) => photo(r.photo_path, `gr-log-${r.id}`)],
  ],
};

export function GateRegisterTable({ tab, rows }) {
  const cols = COLS[tab];
  return (
    <div className="border border-canvas-line bg-white overflow-x-auto">
      <table className="w-full text-sm" data-testid={`gr-table-${tab}`}>
        <thead className="bg-canvas-panel">
          <tr className="text-left font-mono text-[10px] uppercase tracking-[0.15em] text-ink-muted">
            {cols.map(([h]) => <th key={h} className="px-3 py-2.5 whitespace-nowrap">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={cols.length} className="px-3 py-8 text-center text-xs text-ink-subtle">Nothing in this period.</td></tr>}
          {rows.map((r) => (
            <tr key={r.id} className={`border-t border-canvas-line align-top ${r.overdue ? "bg-[#fde8e8]" : ""}`} data-testid={`gr-row-${r.id}`}>
              {cols.map(([h, fn]) => <td key={h} className="px-3 py-2">{fn(r)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
